import React from 'react';
import ContactForm from "./ContactForm";
import Topper from '../topper';
import Bottomd from '../bottomd';
import './Contact.css'; // Import the new CSS file

function Contact() {
  return (
    <div className="App" style={{ overflowX: 'hidden', maxWidth: '100%' }}>
      <header className="App-header">
        <div className="branding-logo">
          <Topper />
        </div>
      </header>

      <div className="contact-header">
        <h1 className="neon-text">contact us</h1>
        <div className="cyber-line"></div>
      </div>

      <div className="contact-container">
        <div className="contact-content">
          <div className="contact-sidebar">
            <div className="info-card">
              <div className="info-card-header">
                <span className="info-icon">📞</span>
                <h3>Get in Touch</h3>
              </div>
              <p className="info-description">
                Find out how our modern SaaS platform and community of trusted security experts can help you stay ahead of evolving threats.
                <br /><br />
                Our team of experts provides comprehensive security solutions tailored to your organization's specific needs. We typically respond to all inquiries within 24 hours during business days.
              </p>
            </div>
          </div>

          <div className="contact-form-display">
            <div className="contact-form-card">
              <div className="contact-form-header">
                <span className="contact-form-icon">✉️</span>
                <h3>Send us a message</h3>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      
      <div>
        <Bottomd />
      </div>
    </div>
  );
}

export default Contact;